import { getAvilableNodesAndOperation } from '@mdm/api/contractManage/mipIframeApi.js';
import { getAuditeNoteAllApi, getProcessTableInfoAndManualNodesApi } from '@/modules/mdm/api/contractManage/mipIframeApi.js';

// import _ from 'lodash';
/**
 * params.fdId          array   流程ID
 * params.loginName     string  userCode
 * return 是否存在操作选项
 * */
export const getNodesAndOperationApi = async (params) => {
    try {
        if (!params.fdId) return false;
        let currentData = true;
        const res = await getAvilableNodesAndOperation(params);
        if (+res.code === 0 && res.data) {
            currentData = Array.isArray(res.data) && res.data.length;
        }
        return currentData;
    } catch (error) {
        return false;
    }
};

/**
 * fdId          string   流程ID
 * loginName     string  userCode
 * return 单据关联审批流程相关节点是否包含自己
 * */
export const checkApprovalAuthority = async (fdId, loginName) => {
    try {
        const params = {
            fdId,
            loginName
        };

        // 并行发起两个API请求
        const [processRes, auditRes] = await Promise.all([
            getProcessTableInfoAndManualNodesApi(params),
            getAuditeNoteAllApi(params)
        ]);

        // 检查流程节点权限
        const hasProcessAuthority = processRes.data.processNodes?.some(node =>
            node.handlers?.some(handler => handler.id === loginName)
        );

        // 检查审核记录权限
        const hasAuditAuthority = auditRes.data.body?.data?.some(record =>
            record.fdHandlerId === loginName
        );

        // 返回是否有任一权限
        return hasProcessAuthority || hasAuditAuthority;
    } catch (error) {
        console.error('检查审批权限失败:', error);
        return false;
    }
};
